
import makerjs from "makerjs";
function B34(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param,R = Param[2].param,S1 = Param[3].param,S2 = Param[4].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       b = B * 1 * myZoom,
       l = L * 1 * myZoom,
        r = R * 1 * myZoom,
        s1 = S1 * 1 * myZoom,
        s2 = S2 * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       
       x0 = 0, x1 = s1, x2 =b-s2 ,x3 =b , y0 = 0, y1 = l,y2 = r, y3 =0,glassH =l, glassW = b,h=l,w=b;

   if (b !== 0) {
       var TxtB ="B="+ B;
   }  if (l !== 0) {
    var TxtL = "L="+L;
  }  if (r !== 0) {
    var TxtR = "R="+R;
  }  if (s1 !== 0) {
    var TxtS1 = "S1="+S1;
  } if (s2 !== 0) {
    var TxtS2 = "S2="+S2;
  } 



   var drawAbnormalShapeB34 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "TopLine":new makerjs.paths.Line([x1,y1], [x2,y2]), 
        "RightLine":new makerjs.paths.Line([x2,y2], [x3,y3]), 
        "BottomLine": new makerjs.paths.Line([x3,y3], [x0, y0]),
       }
   };
   var drawAbnormalShapeB34MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x0- markShift, y0], [x0- markShift, y1]),
        "RightShortUpline": new makerjs.paths.Line([x0, y1], [x0- 2 * markShift, y1]),
        "RightShortDnline": new makerjs.paths.Line([x0, y0], [x0- 2 * markShift, y0]),
       }
   };
   var drawAbnormalShapeB34MarkR = {
       paths: {
        "RightLine": new makerjs.paths.Line([x3+ markShift, y3], [x3+ markShift, y2]),
        "RightShortUpline": new makerjs.paths.Line([x3, y2], [x3+ 2 * markShift, y2]),
        "RightShortDnline": new makerjs.paths.Line([x3, y3], [x3+ 2 * markShift, y3]),
       }
   };
   var drawAbnormalShapeB34MarkB = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0- markShift], [x3, y3- markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 - 2 * markShift]),
       }
  
   };
   var drawAbnormalShapeB34MarkS1 = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y1+ markShift], [x1, y1+ markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y1], [x0, y1 + 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x1, y1], [x1, y1 + 2 * markShift]),
       }
  
   };
   var drawAbnormalShapeB34MarkS2 = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x2, y2+ markShift], [x3, y2+ markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x2, y2], [x2, y2 + 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x3, y2], [x3, y2 + 2 * markShift]),
       }
  
   };
   makerjs.model.addCaption(drawAbnormalShapeB34MarkB, TxtB, [x0, y0 - 2 * markShift], [x3, y3 - 2 * markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB34MarkS1, TxtS1, [x0, y1+ 2*markShift], [x1, y1+ 2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB34MarkS2, TxtS2, [x2, y2+ 2*markShift], [x3, y2+ 2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB34MarkL, TxtL, [x0-2*markShift, y0], [x0-2*markShift, y1]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeB34MarkR, TxtR, [x3+ 3*markShift, y3], [x3+ 3*markShift, y2]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeB34: drawAbnormalShapeB34,
      }
    };
    markers={
      models: {
        drawAbnormalShapeB34: drawAbnormalShapeB34,
        drawAbnormalShapeB34MarkL: drawAbnormalShapeB34MarkL,
        drawAbnormalShapeB34MarkR: drawAbnormalShapeB34MarkR,
        drawAbnormalShapeB34MarkB:drawAbnormalShapeB34MarkB,
        drawAbnormalShapeB34MarkS1: drawAbnormalShapeB34MarkS1,
        drawAbnormalShapeB34MarkS2: drawAbnormalShapeB34MarkS2,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B34;